import React from "react";
import logo from "@/assets/logo-white.png";

export function AuthFrame({ children }) {
  return (
    <div className="min-h-screen bg-surface flex flex-col items-center justify-center px-5 py-12 relative">
      <div
        className="absolute inset-0 opacity-[0.10] pointer-events-none"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1609083590460-7b8cc0ca65f8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-surface/40 via-surface/70 to-surface pointer-events-none" />
      <div className="relative w-full max-w-md em-fade-up">
        <div className="flex justify-center mb-8">
          <img src={logo} alt="Primal Integrity" className="w-24 opacity-80" />
        </div>
        {children}
      </div>
    </div>
  );
}
